
export const registeredComponents : QuotationComponent[] = [];

export function registerQuotationComponent(quotationComponent : QuotationComponent) : void {
  registeredComponents.push(quotationComponent);
}

export interface QuotationComponent {
}
